import { render } from "./SidebarProfile.vue?vue&type=template&id=716c033f&scoped=true&ts=true"
import script from "./SidebarProfile.vue?vue&type=script&lang=ts"
export * from "./SidebarProfile.vue?vue&type=script&lang=ts"

import "./SidebarProfile.vue?vue&type=style&index=0&id=716c033f&scoped=true&lang=css"
import "./SidebarProfile.vue?vue&type=style&index=1&id=716c033f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716c033f"],['__file',"src/layouts/sidebar/SidebarProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "716c033f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('716c033f', __exports__)) {
    api.reload('716c033f', __exports__)
  }
  
  module.hot.accept("./SidebarProfile.vue?vue&type=template&id=716c033f&scoped=true&ts=true", () => {
    api.rerender('716c033f', render)
  })

}


export default __exports__